import { Text } from '@kanda-libs/ks-design-library';
import { WorkType } from '@kanda-libs/ks-frontend-services';
import InfoPill from 'components/shared/InfoPill';
import { useMemo } from 'react';
import { formatWorkTypesToOptions } from 'utils';

export interface LayoutSidebarWorkTypesProps {
  workTypes?: WorkType[];
  isLoading?: boolean;
}

export const PLACEHOLDER_WORKTYPES = [
  {
    name: 'placeholder1',
    value: 'placeholder1',
  },
  {
    name: 'placeholder2',
    value: 'placeholder2',
  },
  {
    name: 'placeholder3',
    value: 'placeholder3',
  },
  {
    name: 'placeholder4',
    value: 'placeholder4',
  },
];

const LayoutSidebarWorkTypes: React.FunctionComponent<LayoutSidebarWorkTypesProps> =
  function ({ workTypes, isLoading = false }) {
    const formattedWorkTypes = useMemo(() => {
      if (isLoading || !workTypes) return PLACEHOLDER_WORKTYPES;
      return formatWorkTypesToOptions(workTypes);
    }, [isLoading, workTypes]);

    const show = useMemo(() => {
      if (isLoading) return true;
      if (!workTypes) return false;
      return workTypes.length > 0;
    }, [isLoading, workTypes]);

    if (!show) return undefined;
    return (
      <div className="w-full flex flex-col">
        <Text
          isLoading={isLoading}
          text="Works We Cover"
          className="text-16-24-em mb-3"
        />
        <div className="flex flex-row flex-wrap gap-x-3 gap-y-2">
          {formattedWorkTypes.map((formatted) => (
            <InfoPill
              id={formatted.value}
              content={formatted.name}
              key={formatted.value}
              isLoading={isLoading}
            />
          ))}
        </div>
      </div>
    );
  };

export default LayoutSidebarWorkTypes;
